import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { ServiceIcon } from '../ServiceIcon/ServiceIcon.es.js';
import { ServiceIconConfig } from '../ServiceIcon/constants.es.js';
import { ServiceIconNumeric } from './ServiceIconNumeric.es.js';

const Styles = labelStyles("ServiceIcons", {
  root: (iconSpacing, iconSize, isBlock) => [
    css`
      --border-radius-fallback: ${ServiceIconConfig[iconSize].borderRadius}px;

      li:not(:first-of-type):not(:last-of-type):not(:only-of-type) span {
        border-radius: var(--zds-space-0, var(--border-radius-fallback));
        border-left-width: var(--zds-space-0, 1px);
      }
      li:first-of-type:not(:only-of-type) span {
        border-top-right-radius: var(
          --zds-space-0,
          var(--border-radius-fallback)
        );
        border-bottom-right-radius: var(
          --zds-space-0,
          var(--border-radius-fallback)
        );
      }
      li:last-of-type:not(:only-of-type) span {
        border-top-left-radius: var(
          --zds-space-0,
          var(--border-radius-fallback)
        );
        border-bottom-left-radius: var(
          --zds-space-0,
          var(--border-radius-fallback)
        );
        border-left-width: var(--zds-space-0, 1px);
      }

      display: ${isBlock ? "grid" : "inline-grid"};
      user-select: none;
      grid-gap: var(--zds-space-0, ${iconSpacing}px);
      grid-auto-flow: column;
      list-style: none;
    `,
    isBlock && css`
        width: fit-content;
      `
  ]
});
const ServiceIcons = ({ ariaLabel, hasBorder = true, hasWhiteBackground = false, maxServices = 6, renderServiceIcon, services, size = 40, isBlock }) => {
  const props = {
    ariaLabel,
    hasBorder,
    services,
    hasWhiteBackground,
    maxServices,
    renderServiceIcon,
    size,
    isBlock
  };
  const { spacing } = ServiceIconConfig[size];
  const label = ariaLabel || `${services.length} apps mentioned`;
  const hasExtraServices = services.length > maxServices;
  const numServicesHidden = hasExtraServices ? services.length - maxServices + 1 : 0;
  const numServicesShown = hasExtraServices ? maxServices - 1 : services.length;
  let visibleServices = [];
  if (numServicesShown === 1) {
    visibleServices = [services[0]];
  } else if (numServicesShown >= 2) {
    visibleServices = [
      ...services.slice(0, numServicesShown - 1),
      services[services.length - 1]
    ];
  }
  const icons = visibleServices.map((service, idx) => jsx("li", { key: idx, "data-zds": true }, renderServiceIcon ? renderServiceIcon(service, props) : jsx(ServiceIcon, { hasBorder, hasWhiteBackground, serviceName: service.name, size, src: service.src })));
  if (hasExtraServices) {
    const hiddenServicesCountIcon = jsx(
      "li",
      { key: `remainder-${numServicesHidden}`, "data-zds": true },
      jsx(ServiceIconNumeric, { size, number: numServicesHidden, hasBorder, hasWhiteBackground })
    );
    if (maxServices > 2)
      icons.splice(-1, 0, hiddenServicesCountIcon);
    else
      icons.push(hiddenServicesCountIcon);
  }
  return jsx("ul", { "aria-label": label, css: Styles.root(spacing, size, isBlock), "data-zds": true }, icons);
};

export { ServiceIcons };
//# sourceMappingURL=ServiceIcons.es.js.map
